import { MyPagesStartModel } from "$shared/models/mod.ts";

import api, { fromApi, intoModel } from "$shared/lib/api-parkito2.svelte.ts";

export const myPages = fromApi(() =>
  api
    .startMyPages({})
    .then(intoModel(MyPagesStartModel))
);
